import { useContext, useEffect, useMemo, useState } from "react"
import { ToastContext } from "../../../context/ToastContext";
import _ from "underscore";
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import { callautopopulate } from "../../../services/callautopop";
import { calculateWordsFromString, convertToBase64 } from "../../../utils/Helper";
import { useCommon } from "../Pocker/useCommon";

export const useCreateTicket = ({ options, selectedData, getRequestData, onHide }) => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [formValue, setFormValue] = useState({
        files: [],
        approval: false
    });
    const [subType, setSubType] = useState([]);
    const [userInfo, setUserInfo] = useState({});
    const [prevData, setPrevData] = useState({ files: [] });
    const [statusOpts, setStatusOpts] = useState([]);
    const [requestTypeColumns, setRequestTypeColumns] = useState([]);
    const [requestTypeColumnValues, setRequestTypeColumnValues] = useState([]);
    const [prevColumnsValues, setPrevColumnsValues] = useState([]);
    const [approverList, setApproverList] = useState([]);
    const [dynamicField, setDynamicField] = useState([]);
    const [loader, setLoader] = useState(false);
    const { getSubProject } = useCommon();

    useEffect(() => {
        setStatusOpts(options?.requestStatus);
        callautopopulate("user_info").then(res => {
            setUserInfo(res?.user_info?.[0]);
        });

        if (selectedData && !_.isEmpty(selectedData) && options?.allType?.length) {
            const fullPathArray = buildParentTreePath(
                selectedData?.request_type_id,
                options?.allType,
                options?.requestType
            );
            setDynamicField(fullPathArray);
            const directLeafOptions = _.filter(options?.subRequestType, {
                request_type_id: selectedData?.request_type_id
            });
            setSubType(directLeafOptions);
            const exactTypeNode = fullPathArray[fullPathArray.length - 1] ||
                _.find(options?.allType, { request_type_id: selectedData?.request_type_id });

            const status = _.find(options?.requestStatus, { status_id: selectedData?.status_id });

            if (status?.status_name?.toLowerCase() !== "new") {
                setStatusOpts(_.filter(options?.requestStatus, (item) => item?.status_name?.toLowerCase() !== "new"));
            }
            if (selectedData?.created_by === userInfo?.user_code) {
                setStatusOpts(_.uniq([...[status], ..._.filter(options?.requestStatus, (item) => item?.status_name?.toLowerCase() === "re open" || item?.status_name?.toLowerCase() === "close")], "status_id"));
            }

            const dataObj = {
                requestType: exactTypeNode,
                subType: _.find(options?.subRequestType, { request_sub_type_id: selectedData?.request_sub_type_id }),
                comments: selectedData?.comments,
                summary: selectedData?.ticket_summary,
                subject: selectedData?.ticket_subject,
                priority: _.find(options?.priorityOption, { priority_id: selectedData?.priority_id }),
                status: status,
                ticket_id: selectedData?.ticket_id,
                files: selectedData?.media,
                createdBy: selectedData?.created_by,
                approver_user_code: selectedData?.approver_user_code,
                project: selectedData?.project_id,
                approval: selectedData?.approver_user_code || selectedData?.project_id ? true : false,
                requested_user_code: selectedData?.created_by
            };

            selectedData?.project_id && getApproverList(selectedData?.project_id);

            const filteredArray = selectedData?.request_type_column_values?.map(item => ({
                base64_string: item?.is_media ? item?.request_type_column_value : "",
                request_type_column_id: item.request_type_column_id,
                request_type_column_value: !item?.is_media ? item.request_type_column_value : "",
                request_type_column_value_id: item.request_type_column_value_id
            }));

            setRequestTypeColumnValues(filteredArray);
            setPrevColumnsValues(filteredArray);
            setFormValue((prev) => ({ ...prev, ...dataObj }));
            setPrevData((prev) => ({ ...prev, ...dataObj }));
        }

    }, [selectedData, options?.requestStatus, options?.allType, options?.subRequestType]);

    const buildParentTreePath = (targetTypeId, allTypes, rootTypes) => {
        const path = [];
        let currentId = targetTypeId;
        while (currentId) {
            const matchingType = _.find(allTypes, { request_type_id: currentId });
            if (!matchingType) break;
            path.unshift(matchingType);
            currentId = matchingType.parent_request_type_id;
        }
        if (path.length > 0 && rootTypes) {
            const rootMatch = _.find(rootTypes, { request_type_id: path[0].request_type_id });
            if (rootMatch) {
                path[0] = rootMatch;
            }
        }

        return path;
    };


    const handleOnChange = (e) => {
        const { name, value } = e.target
        if (name === "approval") {
            setFormValue((prev) => ({ ...prev, [name]: e.target.checked, upsert: true }))
        } else if (name === "project") {
            setFormValue((prev) => ({ ...prev, [name]: value, upsert: true }))
            getApproverList(value)
        }
        else if (name !== "status" && name !== "newComments") {
            setFormValue((prev) => ({ ...prev, [name]: value, upsert: true }))
        } else {
            setFormValue((prev) => ({ ...prev, [name]: value, upsert: false }))
        }
    }

    useEffect(() => {
        const columns = _.filter(options?.requestTypeColumns, { request_sub_type_id: formValue?.subType?.request_sub_type_id })
        setRequestTypeColumns(columns)
    }, [formValue?.subType])


    const handleDropdownChange = (newValue, index) => {
        if (!newValue) return;
        const updatedPath = dynamicField.slice(0, index);
        updatedPath[index] = newValue;
        setDynamicField(updatedPath);
        const currentId = newValue?.request_type_id;
        const childCategories = _.filter(options?.allType, { parent_request_type_id: currentId });
        if (childCategories.length > 0) {
            setSubType([]);
            setFormValue((prev) => ({ ...prev, subType: null }));
        } else {
            const leafSubtypes = _.filter(options?.subRequestType, { request_type_id: currentId });

            setFormValue((prev) => ({
                ...prev,
                requestType: newValue,
                subType: null
            }));
            setSubType(leafSubtypes);
        }
        setRequestTypeColumns([]);
        setRequestTypeColumnValues([]);
    };

    const handleCreateTicket = async (e) => {
        try {
            e.preventDefault();
            let missingField = null;
            for (const val of requestTypeColumns) {
                if (val.is_required) {
                    const userInput = requestTypeColumnValues.find(
                        item => item.request_type_column_id === val.request_type_column_id
                    );
                    if (!userInput) {
                        missingField = val.request_type_column_name;
                        break;
                    }
                    if (val.is_media) {
                        if (!userInput.base64_string || userInput.base64_string === "") {
                            missingField = val.request_type_column_name;
                            break;
                        }
                    } else {
                        if (!userInput.request_type_column_value || !userInput.request_type_column_value.trim()) {
                            missingField = val.request_type_column_name;
                            break;
                        }
                    }
                }
            }

            if (_.isEqual(formValue, prevData) && _.isEqual(requestTypeColumnValues, prevColumnsValues) && formValue?.ticket_id) {
                showInfo("info", "No changes made");
                return;
            }
            if (!formValue?.requestType?.request_type_id) {
                showInfo("info", "Please select request type or category");
                return;
            }
            if (!formValue?.subType?.request_sub_type_id && subType?.length > 0) {
                showInfo("info", "Please select sub request type");
                return;
            }
            if (missingField) {
                showInfo("info", `${missingField} is required`);
                return;
            }
            if (!formValue?.subject?.trim()) {
                showInfo("info", "Please enter a subject");
                return;
            }
            if (!formValue?.priority?.priority_id) {
                showInfo("info", "Please select a priority");
                return;
            }
            if (formValue?.approval && !formValue?.project) {
                showInfo("info", "Please select a project.");
                return;
            }
            if (formValue?.approval && formValue?.project && !formValue?.approver_user_code) {
                showInfo("info", "Please select an approver.");
                return;
            }
            if (!formValue?.summary?.trim()) {
                showInfo("info", "Please enter summary");
                return;
            } else if (calculateWordsFromString(formValue?.summary) < 5) {
                showInfo("info", "Summary should contain minimum 5 words");
                return;
            }

            setLoader(true);
            const payload = {
                "ticket_id": formValue?.ticket_id || 0,
                "request_type_id": formValue?.requestType?.request_type_id,
                "request_sub_type_id": formValue?.subType?.request_sub_type_id,
                "priority_id": formValue?.priority?.priority_id,
                // "status_id": formValue?.status?.status_id,
                "ticket_subject": formValue?.subject,
                "ticket_summary": formValue?.summary || "",
                "ticket_media_id": _.pluck(formValue.files, 'ticket_media_id').map(id => id || 0).join(','),
                "ticket_base64": _.uniq(_.pluck(formValue?.files, "base64")).toString(),
                "request_type_column_values": requestTypeColumnValues,
                "is_approver": formValue?.approval || false,
                "project_id": formValue?.approval ? formValue?.project : 0,
                "approver_user_code": formValue?.approval ? formValue?.approver_user_code : 0,
                "requested_user_code": formValue?.requested_user_code || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTTICKETREQUEST"), payload)
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                getRequestData()
                onHide()
                setSubType([])
                setFormValue({ files: [] })
                setPrevData({ files: [] })
            } else {
                showError("error", res.body.errorMessage)
            }
        } catch (error) {
            console.error("error::", error)
        } finally {
            setLoader(false);
        }
    }

    const saveStatus = async (e) => {
        try {
            e.preventDefault();
            if (formValue?.status?.status_name === "New") {
                showInfo("info", "Please update status");
                return;
            }
            if (!formValue?.newComments?.trim()) {
                showInfo("info", "Please enter Remark")
                return
            }
            setLoader(true);
            const payload = {
                "ticket_id": formValue?.ticket_id,
                "remarks": formValue?.newComments?.trim(),
                "status_id": formValue?.status?.status_id,
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTTICKETSTATUSREMARKS"), payload)
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                const newCommentObj = {
                    ticket_id: formValue?.ticket_id,
                    comments: formValue?.newComments,
                    commented_by: userInfo?.user_code,
                    commented_user_name: userInfo?.user_display_name,
                    commented_date: new Date().toISOString()
                };
                setFormValue((prev) => ({
                    ...prev,
                    comments: [...(prev.comments || []), newCommentObj]
                }));
                getRequestData()
                onHide()
                setSubType([])
                setFormValue({ files: [] })
                setPrevData({ files: [] })
            } else {
                showError("error", res.body.errorMessage)
            }

        } catch (error) {
            console.error("error::", error)
        } finally {
            setLoader(false);
        }
    }

    const dynamicInputHandle = async (e, val) => {
        if (val.is_media) {
            const file = e.target.files[0];
            const maxSizeInBytes = 20 * 1024 * 1024;
            if (file.size >= maxSizeInBytes) {
                showError("Error", "File size should not exceed 20MB");
                return;
            }
            const base64String = await convertToBase64(file);
            setFormValue(prev => ({ ...prev, upsert: true }));
            setRequestTypeColumns(prev => {
                const copy = [...prev];
                const idx = copy.findIndex(item => item.request_type_column_id === val.request_type_column_id);
                const newEntry = {
                    ...val,
                    value: file
                };
                if (idx > -1) {
                    copy[idx] = newEntry;
                } else {
                    copy.push(newEntry);
                }
                return copy;
            });

            setRequestTypeColumnValues(prev => {
                const copy = [...prev];
                const idx = copy.findIndex(item => item.request_type_column_id === val.request_type_column_id);
                const newEntry = {
                    request_type_column_value_id: idx > -1 ? copy[idx].request_type_column_value_id : 0,
                    request_type_column_id: val.request_type_column_id,
                    request_type_column_value: "",
                    base64_string: base64String?.split(",")?.[1]
                };
                if (idx > -1) {
                    copy[idx] = newEntry;
                } else {
                    copy.push(newEntry);
                }
                return copy;
            });
        } else {
            const inputValue = e.target.value;
            setFormValue(prev => ({ ...prev, upsert: true }));
            setRequestTypeColumnValues(prev => {
                const copy = [...prev];
                const idx = copy.findIndex(item => item.request_type_column_id === val.request_type_column_id);
                const newEntry = {
                    request_type_column_value_id: idx > -1 ? copy[idx].request_type_column_value_id : 0,
                    request_type_column_id: val.request_type_column_id,
                    request_type_column_value: inputValue,
                    base64_string: ""
                };
                if (idx > -1) {
                    copy[idx] = newEntry;
                } else {
                    copy.push(newEntry);
                }
                return copy;
            });
        }
    };

    const getApproverList = async (value) => {
        const data = await getSubProject(value, ["is_approver"], userInfo?.userCode);
        setApproverList(_.sortBy(data?.approver, "user_display_name"))

    }

    const layoutConfig = useMemo(() => {
        const activeNestedItems = dynamicField.filter(currentSelection => {
            const currentId = currentSelection?.request_type_id;
            if (!currentId) return false;
            return _.some(options?.allType, { parent_request_type_id: currentId });
        });

        const totalVisibleDropdowns = 2 + activeNestedItems.length;
        const isOddCount = totalVisibleDropdowns % 2 !== 0;

        return {
            activeNestedIds: activeNestedItems.map(item => item.request_type_id),
            isOddCount,
            rootClass: (totalVisibleDropdowns === 1) && isOddCount ? "col-12 mb-1" : "col-md-6 col-12 mb-1",
            subTypeClass: isOddCount ? "col-12 mb-1" : "col-md-6 col-12 mb-1"
        };
    }, [dynamicField, options?.allType]);
    const handleCloseModal = (e) => {
        if (e) e.preventDefault();
        onHide();
        setFormValue({ files: [] });
        setPrevData({ files: [] });
        setSubType([]);
    };



    return useMemo(() => ({
        handleOnChange, formValue, setFormValue, handleCreateTicket, subType, setSubType, saveStatus, setPrevData, statusOpts, userInfo, requestTypeColumns, dynamicInputHandle, requestTypeColumnValues, approverList, dynamicField, handleDropdownChange, handleCloseModal, layoutConfig, loader
    }), [handleOnChange, formValue, setFormValue, handleCreateTicket, subType, setSubType, saveStatus, setPrevData, statusOpts, userInfo, requestTypeColumns, dynamicInputHandle, requestTypeColumnValues, approverList, dynamicField, handleDropdownChange, handleCloseModal, layoutConfig, loader])
}
